/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdaysun3Inputs */

const en_placewebdaysun3 = /** @type {(inputs: Placewebdaysun3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sun`)
};

const de_placewebdaysun3 = /** @type {(inputs: Placewebdaysun3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So`)
};

/**
* | output |
* | --- |
* | "Sun" |
*
* @param {Placewebdaysun3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdaysun3 = /** @type {((inputs?: Placewebdaysun3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdaysun3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdaysun3(inputs)
	return de_placewebdaysun3(inputs)
});
export { placewebdaysun3 as "placeWebDaySun" }